export enum PagePath {
  home = '/',
  roles = '/roles',
  role = '/roles/:roleId',
  skills = '/skills',
  skill = '/skills/:skillId',
  article = '/article/:topicId',
  questions = '/questions/:contentId',
  topics = '/topics/:skillId/:skillLevel',
}